import React, { useState } from 'react';
import { Reveal, Eyebrow } from '../ui';

const faqs = [
  { q: 'Is Max & Sherry free to use?', a: 'Yes — you can download the app and browse on the Explorer plan at MWK 15,000/month. For unlimited access, upgrade to Connect or Exclusive.' },
  { q: 'How do connections work?', a: 'When you like someone\'s profile and they like yours back, it\'s a connection! You both get notified and a private chat opens. Neither person can message the other until it\'s mutual.' },
  { q: 'Which cities are supported?', a: 'Max & Sherry is available across all cities and towns in Malawi — from Lilongwe and Blantyre to Mzuzu, Zomba, Kasungu, Mangochi, Salima, Dedza, Karonga, Liwonde, and beyond.' },
  { q: 'How do I get my profile verified?', a: 'Go to your profile settings and tap "Get verified". Submit a government-issued ID. Once approved, a verified badge appears on your profile.' },
  { q: 'What is the Exclusive plan?', a: 'Exclusive (MWK 100,000/month) gives you everything in Connect plus manual matchmaking — the Max & Sherry team personally curates profiles for you. You also get a verified badge automatically.' },
  { q: 'Can I cancel my subscription anytime?', a: 'Yes. Cancel anytime from your profile settings. You\'ll keep access until the end of your current billing period.' },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section className="py-16 lg:py-[100px] px-[5%] bg-blush" id="faq">
      <Reveal><Eyebrow>FAQ</Eyebrow></Reveal>
      <Reveal delay={100}>
        <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] mb-3">Common questions</h2>
      </Reveal>
      <Reveal delay={150}>
        <p className="text-base text-muted mb-8 lg:mb-14">Everything you need to know before you download.</p>
      </Reveal>
      <Reveal>
        <div className="max-w-[760px] flex flex-col">
          {faqs.map((f, i) => (
            <div key={i} className="border-t border-black/8 last:border-b last:border-black/8">
              <button onClick={() => setOpen(open === i ? null : i)}
                className="w-full bg-transparent border-none text-left py-[22px] text-base font-semibold cursor-pointer flex justify-between items-center gap-4 text-black font-sans">
                {f.q}
                <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${open === i ? 'bg-black' : 'bg-blush-mid'}`}>
                  <svg viewBox="0 0 12 12" fill="none" stroke={open === i ? 'white' : 'black'} strokeWidth="2.5" strokeLinecap="round"
                       className={`w-3 h-3 transition-transform duration-300 ${open === i ? 'rotate-45' : ''}`}>
                    <line x1="6" y1="1" x2="6" y2="11"/><line x1="1" y1="6" x2="11" y2="6"/>
                  </svg>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-[350ms] ${open === i ? 'max-h-[300px]' : 'max-h-0'}`}>
                <p className="text-[15px] text-muted leading-relaxed pb-[22px]">{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
